import { Volume2 } from 'lucide-react';
import { cn } from '@/lib/utils';
import peninsulaLogo from '@/assets/peninsula-logo.svg';

interface LogoProps {
  className?: string;
  dark?: boolean;
}

export function Logo({ className, dark = false }: LogoProps) {
  return (
    <span className={cn('inline-flex items-center gap-2 font-bold text-xl', className)}>
      <Volume2 className="size-6 text-peninsula-magma" aria-hidden="true" />
      Readable
      <span className={cn(
        'inline-flex items-center gap-1.5 text-xs font-normal',
        dark ? 'opacity-60' : 'text-muted-foreground',
      )}>
        by
        <a href="https://peninsula.co" target="_blank" rel="noopener noreferrer">
          <img
            src={peninsulaLogo}
            alt="Peninsula"
            className={cn('h-3.5', dark && 'brightness-0 invert')}
          />
        </a>
      </span>
    </span>
  );
}
